import { observable, computed } from 'mobx';
import { PermissionedModel } from 'apps/permissions/app';
import { Model, ModelRegistry } from 'core';
import { TagModel } from 'apps/tag/app';

export class LabelModel extends PermissionedModel {
  static registryName = 'LabelModel';
  @observable name = '';
  @observable color = '';
  @observable restricted = false;
}
ModelRegistry.add(LabelModel);

export class IssueModel extends PermissionedModel {
  static registryName = 'IssueModel';
  static ModelProps = {
    creatorProfile: 'ProfileModel',
    labels: [LabelModel],
    commenters: ['ProfileModel'],
    assignees: ['ProfileModel'],
    inSpace: 'SpaceModel',
    project: 'ProjectModel',
    tags: [TagModel],
  };

  @observable id = '';
  @observable slug = '';
  @observable number = 0;
  @observable status = '';
  @observable title = '';
  @observable description = '';
  @observable labels = [];
  @observable creatorProfile = null;
  @observable assignees = [];
  @observable commenters = [];
  @observable comments = [];
  @observable creator = '';
  @observable dateCreated = '';
  @observable lastUpdated = '';
  @observable inSpace = null;
  @observable canAddDeleteLabels = false;
  @observable project = null;
  @observable tags = [];

  @computed get commentsCount() {
    if (this.comments) {
      return this.comments.totalCount;
    }
    return 0;
  }
}
ModelRegistry.add(IssueModel);

export class IssueTrackerModel extends Model {
  static registryName = 'IssueTrackerModel';
  static ModelProps = {
    labels: [LabelModel],
  };

  @observable labels = [];
  @observable openIssuesCount = -1;
  @observable closedIssuesCount = -1;
}
ModelRegistry.add(IssueTrackerModel);
